module.exports = __webpack_public_path__ + "img/bg_map_route.e4477e0f.png";